<script>

    import Common from "../../public/lib/common";
    import App from "../App.svelte";

    let client = {};
    let title = "";
    let currentCallback = null;

    function validateClient() {
        if (!Common.isValidPesel(client.pesel)) {
            return "Nieprawidłowy PESEL";
        }
        if (!client.idSerialNumber || client.idSerialNumber.length !== 9) {
            return "Nieprawidłowy numer dowodu osobistego";
        }
        if (!client.phone || client.phone.length !== 9) {
            return "Nieprawidłowy numer telefonu";
        }
        if (client.mail && client.mail.length && !Common.validateEmail(client.mail)) {
            return "Nieprawidłowy adres e-mail";
        }
        if (client.defaultNip && client.defaultNip.length && client.defaultNip.length !== 10) {
            return "Nieprawidłowy numer NIP";
        }
        if (!client.address || client.address.length === 0) {
            return "Brak adresu";
        }
        if (!client.postalCode || client.postalCode.length === 0) {
            return "Brak kodu pocztowego";
        }
        if (!client.city || client.city.length === 0) {
            return "Brak miasta";
        }
        return null;
    }

    Common.eventBus.on('editClient', function (clientVal, callback) {
        currentCallback = callback;
        let w = jQuery('#clientModal').modal();
        title = "Edycja klienta";
        client = clientVal;
        client.idExpirationDate = Common.convertFromUnixTimeToDDMMYYYY(client.idExpirationDate);
        jQuery('#expiration').flatpickr({
            locale: "pl",
            dateFormat: "d-m-Y",
        });
    });

    Common.eventBus.on('newClient', function (callback) {
        currentCallback = callback;
        let w = jQuery('#clientModal').modal();
        title = "Nowy klient";
        client = {
            mailApprove: false,
            smsApprove: false,
            uuid: ""
        };
        jQuery('#expiration').flatpickr({
            locale: "pl",
            dateFormat: "d-m-Y",
        });
    });

    function save() {
        let errorMessage = validateClient();
        if (errorMessage && errorMessage.length) {
            Swal.fire({
                icon: 'error',
                title: 'Błąd',
                text: errorMessage
            });
            return;
        }
        currentCallback(client);
        jQuery('#clientModal').modal('toggle');
    }
</script>

<div class="modal" tabindex="-1" role="dialog" id="clientModal" style="z-index: 1050; color: black">
    <div class="modal-dialog largeModalDialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title largeFont">{title}</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <h3 class="font-bold text-xl text-center  mb-2">Adres korespondencyjny</h3>

                        <div class="form-group">
                            <label>Adres</label>
                            <input type="text" class="form-control" placeholder="Adres"
                                   bind:value={client.address}>
                        </div>

                        <div class="form-group">
                            <label>Kod pocztowy </label>
                            <input type="text" class="form-control" placeholder="Kod pocztowy"
                                   bind:value={client.postalCode}>
                        </div>

                        <div class="form-group">
                            <label>Miasto </label>
                            <input type="text" class="form-control" placeholder="Miasto"
                                   bind:value={client.city}>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <h3 class="font-bold text-xl text-center  mb-2">Dane osobowe</h3>

                        <div class="form-group">
                            <label>Imię </label>
                            <input type="text" class="form-control" placeholder="Imię"
                                   bind:value={client.name1}>
                        </div>

                        <div class="form-group">
                            <label>Nazwisko </label>
                            <input type="text" class="form-control" placeholder="Nazwisko"
                                   bind:value={client.name2}>
                        </div>

                        <div class="form-group">
                            <label>Telefon </label>
                            <input type="text" class="form-control" placeholder="Telefon"
                                   bind:value={client.phone}>
                        </div>

                        <div class="form-group">
                            <label for="formGroupExampleInput2d">Adres e-mail </label>
                            <input type="text" class="form-control" placeholder="Adres e-mail"
                                   bind:value={client.mail}>
                        </div>

                        <div class="form-group">
                            <label for="formGroupExampleInput2e">Pesel </label>
                            <input type="text" class="form-control" placeholder="Pesel"
                                   bind:value={client.pesel}>
                        </div>

                        <div class="form-group">
                            <label for="formGroupExampleInput2f">Nr dowodu osobistego </label>
                            <input type="text" class="form-control"
                                   placeholder="Nr dowodu osobistego"
                                   bind:value={client.idSerialNumber}>
                        </div>

                        <div class="form-group">
                            <label for="expiration">Data ważności dowodu </label>
                            <input type="text" class="form-control" id="expiration"
                                   placeholder="Data ważności dowodu"
                                   bind:value={client.idExpirationDate}>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">

                        <h3 class="font-bold text-xl text-center mb-2">Dane do faktur</h3>
                        <div class="form-group">
                            <label for="nip">NIP do faktur</label>
                            <input type="text" class="form-control" id="nip"
                                   placeholder="NIP do faktur"
                                   bind:value={client.defaultNip}>
                        </div>

                        <div class="form-group">
                            <label for="nip">Nazwa do faktur</label>
                            <input type="text" class="form-control" id="invoiceName"
                                   placeholder="Nazwa do faktur"
                                   bind:value={client.defaultInvoiceName}>
                        </div>

                        <div class="form-group">
                            <label for="nip">Kod pocztowy do faktur</label>
                            <input type="text" class="form-control" id="invoicePostalCode"
                                   placeholder="Kod pocztowy do faktur"
                                   bind:value={client.defaultInvoicePostalCode}>
                        </div>

                        <div class="form-group">
                            <label for="nip">Miasto do faktur</label>
                            <input type="text" class="form-control" id="invoiceCity"
                                   placeholder="Nazwa do faktur"
                                   bind:value={client.defaultInvoiceCity}>
                        </div>

                        <div class="form-group">
                            <label for="nip">Adres do faktur</label>
                            <input type="text" class="form-control" id="invoiceAddress"
                                   placeholder="Nazwa do faktur"
                                   bind:value={client.defaultInvoiceAddress}>
                        </div>

                        <div class="form-group approveToggle">
                            <label for="formGroupExampleInput2g">Zgoda na mejle </label>
                            <label class="form-switch">
                                <input type="checkbox" bind:checked={client.mailApprove}>
                                <i></i>
                                {#if client.mailApprove === true}
                                    <span>Zgoda</span>
                                {/if}
                                {#if client.mailApprove === false}
                                    <span>Brak zgody</span>
                                {/if}
                            </label>
                        </div>

                        <div class="form-group approveToggle">
                            <label for="formGroupExampleInput2h">Zgoda na smsy </label>
                            <label class="form-switch">
                                <input type="checkbox" bind:checked={client.smsApprove}>
                                <i></i>
                                {#if client.smsApprove === true}
                                    <span>Zgoda</span>
                                {/if}
                                {#if client.smsApprove === false}
                                    <span>Brak zgody</span>
                                {/if}
                            </label>
                        </div>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" on:click={save}><i class="fas fa-save"></i>&nbsp;Zapisz
                </button>
            </div>
        </div>
    </div>
</div>

